export default __webpack_public_path__ + "static/media/donut-voting.9bf3c22b.png";